


















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
@Component
export default class InsFun extends Vue {
  funData: object = {};
  Contents: any[] = [];
  funImg: string = '';
  showImgs: string[] = [];

  FunImgsOption: object = {
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
      observer: true, // 修改swiper自己或子元素时，自动初始化swiper
      observeParents: true // 修改swiper的父元素时，自动初始化swiper
    }
  }

  getFunData () {
    this.$Api.cms.getCategoryByDevice({ CatId: 40115, IsMobile: this.isMobile }).then((result) => {
      this.funData = result;
      this.Contents = result.Contents;

      // this.funImg = this.Contents[0].Cover;

      for (let i = 0; i < this.Contents.length; i++) {
        if (this.Contents[i].Id === 20306) {
          this.funImg = this.Contents[i].Cover;
          break;
        }
      }

      this.Contents.forEach(element => {
        this.showImgs.push(element.Cover);
      });
    });
  }

  showFunImg (id) {
    for (let i = 0; i < this.Contents.length; i++) {
      if (this.Contents[i].Id === id) {
        this.funImg = this.Contents[i].Cover;
      }
    }

    // this.Contents.forEach(item => {
    //   if (item.Id === id) {
    //     this.funImg = item.CmsControl[0].ControlImageLis[0].BigImagePath;
    //   }
    // });
  }

  get isMobile () {
    return this.$store.state.isMobile;
  }

  get lang () {
    return this.$Storage.get('locale');
  }

  mounted () {
    this.getFunData();
  }

  @Watch('isMobile', { deep: true })
  onMediaChange () {
    this.getFunData();
  }
}
